var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useDispatch } from "react-redux";
import { person } from "../../../store/person/actions";
import { plans } from "../../../store/plans/actions";
import { region } from "../../../store/region/actions";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { formatDocument, getLogin, removeNonNumeric, setCampaignData, setPaymentModeData, } from "../../../services/functions";
import { useLocation, useNavigate } from "react-router-dom";
import { getStepNavigation } from "../../../utils/nextBackStep";
import { updateStepByPath } from "../../../utils/updateSteps";
import { insertIntoStepInformation } from "../../../utils/upsertStepInformation";
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
import { getDynamicFormsData } from "../../../utils/getDynamicFormsData";
import { updateStepInLocalStorage } from "../../../utils/updateStapeCustom";
import { addToSummary } from "ah_utility/fnxUtils";
var useCustomer = function (coverTypeSelected, setCoverType, setPaymentSelected, setPlanSelected, responsePlansN, clientId, projectId, setHideMarriedName, enable, page, limit, level2, level3, listGenders, paymentMode, namePlan, paymentModelSelected, setPeriod, paymentSelected, coverType, setListRegionLevel3, Steps, campaingSelected, setCoverTypeSelected, setPaymentMode, setPaymentModelSelected, instanceId, workFlowId, currentStep, nextStep, runComplete) {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _a = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _a[0], setSeeToast = _a[1];
    var pathname = useLocation().pathname;
    var pathLocation = "/" + pathname.split("/")[1];
    var Plan = React.useState(findParamInLocalStorage("Plan"))[0];
    var productCode = React.useState(findParamInLocalStorage("productCode"))[0];
    var dataNavigation = React.useState(getStepNavigation(pathLocation))[0];
    //OBTIENE LA INFORMACION DE LOS FORMULARIOS DINAMICOS
    var dynamicFormsData = getDynamicFormsData();
    var buildSummaryData = function (apiResponse) {
        var lastPrice = apiResponse.lastPrice, firstNameA = apiResponse.firstNameA, firstNameB = apiResponse.firstNameB, lastNameA = apiResponse.lastNameA, lastNameB = apiResponse.lastNameB, numberId = apiResponse.numberId, code = apiResponse.code;
        return [
            {
                label: "Prima",
                value: "".concat(lastPrice.currencySymbol, " ").concat(lastPrice.amount),
            },
            {
                label: "Nombres",
                value: "".concat(firstNameA, " ").concat(firstNameB).trim(),
            },
            {
                label: "Apellidos",
                value: "".concat(lastNameA, " ").concat(lastNameB).trim(),
            },
            {
                label: "Documento",
                value: formatDocument(numberId || ""),
            },
            {
                label: "No. de cotización",
                value: code,
            },
        ];
    };
    var onAcquire = function (item) {
        if (coverTypeSelected) {
            setCoverType(coverTypeSelected);
        }
        else {
            setCoverType(item.option[0]);
        }
        setPaymentSelected(item.paymentMethod);
        setPlanSelected({ id: item.id, name: item.name });
        callDispatchPlan();
    };
    var handleChangeSelect = function (event, id) {
        var value = event.value;
        var name = id;
        if (name === "Province")
            handleChangeProvince(value);
        else if (name === "Town")
            handleChangeTown(value);
        setHideMarriedName(event.name !== "Femenino");
    };
    var handleOnBlur = function (event) {
        var _a = event.target, value = _a.value, id = _a.id;
        //if (id === "DocumentNumber" && value.length > 3)
        // handleChangeDocument(value);
    };
    var handleChangeDocument = function (number) {
        dispatch(person({ enable: enable, page: page, limit: limit, numberId: number }));
    };
    var handleChangeProvince = function (id) {
        dispatch(region({
            enable: enable,
            page: page,
            limit: limit,
            level: level2,
            parentRegionId: id,
        }));
        setListRegionLevel3([{ id: "-1", value: "-1", name: " " }]);
    };
    var handleChangeTown = function (id) {
        dispatch(region({
            enable: enable,
            page: page,
            limit: limit,
            level: level3,
            parentRegionId: id,
        }));
    };
    var handleSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var numberId, gender, hideMarriedName, planIdSelected, planCode, productC, body, res, prevStep, currentStep_1, nextStep_1, apiResponseQuote, summaryData, sessionData, err_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    if (!data) return [3 /*break*/, 4];
                    numberId = (_a = data === null || data === void 0 ? void 0 : data.DocumentNumber) === null || _a === void 0 ? void 0 : _a.replaceAll("-", "");
                    gender = listGenders.find(function (g) { return g.id === data.Gender; });
                    hideMarriedName = (gender === null || gender === void 0 ? void 0 : gender.name) !== "Femenino";
                    planIdSelected = Plan === null || Plan === void 0 ? void 0 : Plan.id;
                    planCode = Plan === null || Plan === void 0 ? void 0 : Plan.code;
                    productC = productCode ? productCode : "";
                    body = {
                        numberId: numberId,
                        identificationTypeId: data.IdType,
                        firstNameA: data.Name,
                        firstNameB: data.SecondName,
                        lastNameA: data.FirstLastName,
                        lastNameB: data.SecondLastName,
                        marriedName: hideMarriedName ? "" : data.MarriedSurName,
                        catalogSexo: data.Gender,
                        dob: data.Birthday,
                        phone1: removeNonNumeric(data.PhoneHome || null),
                        phone2: removeNonNumeric(data.PhoneOffice || null),
                        phone3: removeNonNumeric(data.PhoneNumber || null),
                        address1: data.Address1,
                        address2: data.Address2,
                        province: data.Province,
                        municipality: data.Town,
                        district: data.Sector,
                        nationality: data.Country,
                        email: data.Email,
                        planId: planIdSelected ? planIdSelected : (_b = responsePlansN[0]) === null || _b === void 0 ? void 0 : _b.id,
                        clientId: clientId,
                        zip: data.PostalCode,
                        campaignId: campaingSelected === null || campaingSelected === void 0 ? void 0 : campaingSelected.id,
                        catalogPaymentMode: paymentSelected ? paymentSelected === null || paymentSelected === void 0 ? void 0 : paymentSelected.id : "",
                        coverTypeId: coverType ? coverType === null || coverType === void 0 ? void 0 : coverType.id : "",
                        branch: getLogin().branchId,
                        userId: getLogin().userId,
                    };
                    if (dynamicFormsData) {
                        body = __assign(__assign(__assign({}, body), dynamicFormsData), { planCode: planCode, productCode: productC });
                    }
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, runComplete({
                            workFlowId: workFlowId,
                            instanceId: instanceId,
                            currentStep: currentStep,
                            nextStep: nextStep,
                            sessionData: body,
                        })];
                case 2:
                    res = _l.sent();
                    if (res) {
                        updateStepByPath(pathname);
                        prevStep = (_c = res.upcomingFormStep) === null || _c === void 0 ? void 0 : _c.prevSteps[0];
                        currentStep_1 = (_d = res.upcomingFormStep) === null || _d === void 0 ? void 0 : _d.id;
                        nextStep_1 = (_e = res.upcomingFormStep) === null || _e === void 0 ? void 0 : _e.nextSteps[0];
                        apiResponseQuote = (_h = (_g = (_f = res.sessionData) === null || _f === void 0 ? void 0 : _f.apiResponses) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.data;
                        insertIntoStepInformation({
                            stepKey: pathname,
                            data: {
                                currentStep: currentStep_1,
                                nextStep: nextStep_1,
                                prevStep: prevStep,
                            },
                        });
                        summaryData = buildSummaryData(apiResponseQuote);
                        addToSummary(summaryData);
                        sessionData = ((_j = res.sessionData) === null || _j === void 0 ? void 0 : _j.apiResponses) || [];
                        if (sessionData.length > 0) {
                            updateStepInLocalStorage(pathLocation, sessionData);
                        }
                        navigate("".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.next));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _l.sent();
                    setSeeToast({
                        show: true,
                        message: (_k = err_1 === null || err_1 === void 0 ? void 0 : err_1.message) !== null && _k !== void 0 ? _k : "Ocurrió un error al completar el paso.",
                        type: typeAlert.error,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var choiceInsuranceType = function (value) {
        navigate("/insurance");
    };
    var setCoverTypeStorybook = function (ct) {
        var optionCoverType = [];
        ct.map(function (item) {
            var _a;
            optionCoverType.push({
                name: (_a = item.description) !== null && _a !== void 0 ? _a : "",
                value: item.id,
                id: item.id,
            });
        });
        return optionCoverType;
    };
    var callDispatchPlan = function () {
        if (paymentMode[0].id !== "-1") {
            dispatch(plans({
                enable: enable,
                page: page,
                limit: limit,
                projectId: projectId,
                name: namePlan,
                paymentModeId: paymentModelSelected.id,
                coverTypeId: coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.id,
                clientId: clientId,
            }));
        }
    };
    var onChangeCoverType = function (event) {
        setCoverTypeSelected(event);
    };
    var clickChangePaymentMode = function (event, item) {
        var t = paymentMode.find(function (p) { return p.id === event; });
        if (t) {
            setPeriod(t === null || t === void 0 ? void 0 : t.name);
            setPaymentModelSelected(t);
            //Set selected payment mode
            var pm = paymentMode;
            pm.map(function (item) {
                item.default = false;
                if (item.id === t.id) {
                    item.default = true;
                }
            });
            setPaymentMode(pm);
        }
        else {
            var pm = paymentMode.find(function (p) { return p.value === event; });
            if (pm) {
                if (t) {
                    setPeriod(t.name);
                }
                var ms = setPaymentModeData(event, paymentMode);
                setPaymentMode(ms);
                setPaymentModelSelected(pm);
            }
            else {
                setCampaignData(event);
            }
        }
        callDispatchPlan();
    };
    return {
        onAcquire: onAcquire,
        handleChangeSelect: handleChangeSelect,
        handleOnBlur: handleOnBlur,
        handleChangeDocument: handleChangeDocument,
        handleChangeProvince: handleChangeProvince,
        handleChangeTown: handleChangeTown,
        handleSubmit: handleSubmit,
        choiceInsuranceType: choiceInsuranceType,
        setCoverTypeStorybook: setCoverTypeStorybook,
        onChangeCoverType: onChangeCoverType,
        clickChangePaymentMode: clickChangePaymentMode,
    };
};
export default useCustomer;
